import { forecasts } from '@/repositories/devdata';

export default ({
  namespaced: true,
  state: {
    forecasts: []
  },
  mutations: {
    initialized(state, { forecasts }) {
      state.forecasts = forecasts;
    }
  },
  actions: {
    initialize({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit('initialized', {
            forecasts: forecasts
          });
          resolve();
        }
        catch (e) {
          console.error(e);
          reject();
        }
      })
    }
  },
  getters: {
    forecasts(state) { return state.forecasts; }
  }
});
